import React, { useState, useEffect, useRef } from "react";
    const ProgressBarComponent=({appStatistics})=>{
          const [Inprogressapp, setInprogressapp] = useState([]);

          const styles = {
            h4: {
              color: '#850505',
              textTransform: 'uppercase',
            }
          };
        return (
        <div className="col-md-12">
        <div className="card2">
            <div className="card-body">
              <div className="row">
                <div
                  className="collapse barNav-collapse barNav-1"
                  style={{ marginTop: "0px" }}
                >
                  <b style={{ color: "green" }}>
                    <u>Applications In-progres:</u>
                    &emsp;&emsp;
                  </b>
                  Pending Assessment:&nbsp; | (
                  <text style={styles.h4}>
                    {appStatistics?.TotalAssessmentLevel}
                  </text>
                  ); &emsp; Pending Approval:&nbsp; | (
                  <text style={styles.h4}>
                    {appStatistics?.TotalApproveLevel}
                  </text>
                  ); &emsp; Rejected:&nbsp; | (
                  <text style={styles.h4}>
                    {appStatistics?.TotalRejected}
                  </text>
                  );
                </div>
              </div>
            </div>
        </div>
      </div>
    )
     }
     export default ProgressBarComponent
   